/**
 * factor by which we multiply user movement in pixels.
 *
 * User has to 50% bigger movement to move the slide
 */
export const defaultMovementWeightConstant = 0.5